import {Utils} from '../Utils';

export function BackButton({onClick})
{
	const backBtnText = Utils.tr('BACK_BTN');

	return (
		<button onClick={onClick} className="button is-rounded is-warning is-light is-size-4 style-btn2">
			<i className="fa fa-circle-left pr-2"></i>
			<span>{backBtnText}</span>
		</button>
	);
}